import { useTranslation } from 'react-i18next';
import StickyDownloadCta from './StickyDownloadCta';

const GameOverView = ({ status, deepLink }) => {
  const { t } = useTranslation();
  const isCancelled = status === 'CANCELLED';
  const emoji = isCancelled ? '🚫' : '⏱️';
  const title = isCancelled
    ? t('open.preview.over.cancelledTitle')
    : t('open.preview.over.finalizedTitle');

  return (
    <>
      <div className="gp-over">
        <div className="gp-over__emoji" aria-hidden>{emoji}</div>
        <h1 className="gp-over__title">{title}</h1>
        <p className="gp-over__sub">{t('open.preview.over.findMore')}</p>
      </div>
      <StickyDownloadCta deepLink={deepLink} />
    </>
  );
};

export default GameOverView;
